import { http } from './http';

// Преобразование camelCase -> snake_case
function camelToSnake(str) {
    return String(str).replace(/[A-Z]/g, (m) => '_' + m.toLowerCase());
}

function normalizeDateTime(val) {
    if (!val) return val;
    const s = String(val).trim();
    // Если уже ISO/похоже на ISO — оставляем
    if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}/.test(s)) return s;
    // DD.MM.YYYY HH:MM
    const m = s.match(/^(\d{2})\.(\d{2})\.(\d{4})\s+(\d{2}):(\d{2})$/);
    if (m) {
        const [, dd, mm, yyyy, HH, MM] = m;
        return `${yyyy}-${mm}-${dd}T${HH}:${MM}:00`;
    }
    // DD.MM.YYYY
    const m2 = s.match(/^(\d{2})\.(\d{2})\.(\d{4})$/);
    if (m2) {
        const [, dd, mm, yyyy] = m2;
        return `${yyyy}-${mm}-${dd}T00:00:00`;
    }
    return s;
}

function normalizePayload(payload = {}) {
    const out = {};
    for (const [key, value] of Object.entries(payload)) {
        if (value === undefined) continue;
        if (key === 'dateTime') {
            out['date_time'] = normalizeDateTime(value);
            continue;
        }
        // Индекс желательно отправлять числом, если это число
        if (key === 'idx') {
            const n = typeof value === 'string' ? value.trim() : value;
            const parsed = Number(n);
            out['idx'] = Number.isFinite(parsed) ? parsed : value;
            continue;
        }
        // offenderData -> offender_data и т.п.
        out[camelToSnake(key)] = value;
    }
    return out;
}

export async function listViolations(params = {}) {
    const { data } = await http.get('book/violations/', { params });
    return data;
}

export async function getViolation(id) {
    const { data } = await http.get(`book/violations/${id}/`);
    return data;
}

export async function createViolation(payload) {
    const norm = normalizePayload(payload);
    const { data } = await http.post('book/violations/', norm);
    return data;
}

export async function updateViolation(id, payload) {
    const norm = normalizePayload(payload);
    const { data } = await http.patch(`book/violations/${id}/`, norm);
    return data;
}


export async function deleteViolation(id) {
    const { data } = await http.delete(`book/violations/${id}/`);
    return data;
}